import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-5 mx-4 md:mx-20 lg:mx-36 text-center" }
const _hoisted_2 = { class: "form-control" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label-text" }, "Select your file")
], -1)
const _hoisted_4 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-5 card bg-gray-100"
}
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "card-actions justify-end" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-success mt-5"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "stroke-current shrink-0 h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Copied!", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SiteNavbar = _resolveComponent("SiteNavbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SiteNavbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("input", {
          accept: "text/csv",
          class: "w-full file-input file-input-bordered",
          type: "file",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
        }, null, 32)
      ]),
      (_ctx.sortedData)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-neutral",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.downloadFile && _ctx.downloadFile(...args)))
            }, " Download File "),
            _createElementVNode("button", {
              class: "btn btn-neutral mx-10",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showData = !_ctx.showData))
            }, _toDisplayString(_ctx.showData ? "Hide" : "Show") + " sorted data ", 1),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                (_ctx.showData)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("p", {
                          class: "overflow-y-scroll h-52",
                          innerHTML: _ctx.sortedForHtml
                        }, null, 8, _hoisted_7)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                          class: "btn btn-primary text-white mr-5 mb-5",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.doCopy && _ctx.doCopy(...args)))
                        }, " Copy ")
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_Transition, null, {
              default: _withCtx(() => [
                (_ctx.showAlert)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}